// extracted by mini-css-extract-plugin
export default {"language":"CustomLegalLanguage_language__bNy-e","tooltip":"CustomLegalLanguage_tooltip__dC9fs"};